import {
  availableFeatureFlags,
  useFeatureFlag,
} from './feature-flags-provider';

export const useUses7DayToken = () =>
  useFeatureFlag(availableFeatureFlags.USES_7_DAY_TOKEN, false);
